// extracted by mini-css-extract-plugin
export var alternate = "_1t-j";
export var black = "_1t-6";
export var blue = "_1t-f";
export var blueLight = "_1t-e";
export var brand = "_1t-8";
export var darkMode = "_1t-b";
export var error = "_1t-a";
export var gray = "_1t-5";
export var grayBlue = "_1t-d";
export var iconWrapper = "_1t-3";
export var inactive = "_1t-7";
export var indigo = "_1t-g";
export var orange = "_1t-i";
export var pink = "_1t-h";
export var primary = "_1t-0";
export var purple = "_1t-9";
export var success = "_1t-4";
export var warning = "_1t-c";
export var white = "_1t-1";
export var whiteSuccess = "_1t-2";